import { MonthTermInstallment } from 'widgets/mplus/mplus-payment/component'

import { PaymentType } from '../../../model'

interface Params {
  price: number
  isMplusSelectable?: boolean
  isMInstalmentAvailable?: boolean
}

// Below the installment threshold: regular + M+.
// From the threshold and above: regular + M+ + MInstalment
// (MInstalment only when it is enabled in the user's settings).
export const getAvailableMethods = ({
  price,
  isMplusSelectable,
  isMInstalmentAvailable,
}: Params): PaymentType[] => {
  const methods: PaymentType[] = ['regular']

  if (isMplusSelectable) {
    methods.push('mplus')
  }

  if (
    isMInstalmentAvailable &&
    price >= MonthTermInstallment.firstMeridian.priceOfTicket
  ) {
    methods.push('mInstalment')
  }

  return methods
}
